import config from '@/config';

export function init() {
  /*
	FB.init({
		appId      : config.social.fbAppId,
		cookie     : true,
		xfbml      : true,
		version    : 'v2.8'
	});
	FB.AppEvents.logPageView();
  */
}

export function login() {
	return new Promise((resolve, reject) => {
		window.FB.login(function (response) {
			if (response.authResponse) {
				let today = new Date();
				let expiration = today.getTime() + response.authResponse.expiresIn*1000;

				let info = {
					provider: 'graph.facebook.com',
					token: response.authResponse.accessToken,
					accessToken: response.authResponse.accessToken,
					expiration: expiration
				}
				resolve(info);
			} else {
				resolve(null);
			}
		}, {scope: 'email'});
	});
}



// WEBPACK FOOTER //
// ./src/libs/providers/fb.js